export default "__VITE_ASSET__Otz9K646__"